/*
 * Syntatic sugar
 */
export const qs = (x) => ( document.querySelector(x) );


export const qsa = (x) => ( document.querySelectorAll(x) );

/*
 * Custom get a cookie value
 */
export function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)===' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length,c.length);
        }
    }
    return "";
}

/*
 * callback for detectUserCountry ajax call
 */
export function jsonpSuccess(response) {

  document.cookie = 'userCountry=' + response.country;
  userCountry = response.country;
  
  changePhoneNumbers(userCountry);
}

/*
 * Detect user country and change phones
 */

export function detectUserCountry() {

    //Check user location
    var userCountry = getCookie('userCountry');
    if (userCountry === '') {

      var scr = document.createElement('script')
      scr.src = '//ipinfo.io?callback=jsonpSuccess'
      document.body.appendChild(scr)

    } else {
      changePhoneNumbers(userCountry);
    }

}

export function changePhoneNumbers(userCountry) {

  switch(userCountry) {

    case 'AU':
      qs('.conditional-phone-number-small').innerHTML('1800 316 406');
      qs('.conditional-phone-number-big').innerHTML('1800 316 406');
      qs('.conditional-phone-number-link').setAttribute('href', 'tel:+611800316406');
    break; 

    case 'GB':
      qs('.conditional-phone-number-small').innerHTML('020 3695 0292');
      qs('.conditional-phone-number-big').innerHTML('+44 (0)20 3695 0292');
      qs('.conditional-phone-number-link').setAttribute('href', 'tel:+4402036950292');
    break; 

    case 'US':
      qs('.conditional-phone-number-small').innerHTML('800-646-0796');
      qs('.conditional-phone-number-big').innerHTML('+1 (800) 646-0796');
      qs('.conditional-phone-number-link').setAttribute('href', 'tel:+18006460796');
      qs('.int-locations').before( qs('.us-locations') );
    break;

  }

}

export function openNewWindow() {
  qs("a.btn").setAttribute("target", "_blank");
  qs("a.button").setAttribute("target", "_blank");
}

/*
 * Get query values on URL
 */
export function getParameterByName(name, url) {
  
  if (!url) {
    url = window.location.href;
  }
  
  name = name.replace(/[\[\]]/g, "\\$&");
  
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  
  if (!results) {
    return null;
  }

  if (!results[2]) {
    return '';
  }
  
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/*
 * Automatically insert UTM variables on forms
 */
export function insertUtmInForms() {
  
  var utmList = [ 'utm_source', 'utm_medium', 'utm_campaign' ],
      check = '';

  for (var i = 0; i < utmList.length; i++) { 

    check = getParameterByName( utmList[i] );
    if (check !== null && check !== '') {
      insertUtmInFormsFields( utmList[i], check );
    }
  }

}

export function insertUtmInFormsFields( name, value ) {
  if (qs('form')) {
    qs('form').prepend( '<input type="hidden" name="'+ name +'" value="'+ value +'" />');
  }
}


insertUtmInForms();

/*
 * Convert Month Format
 */
export function convertMonthFormat(date, format) {
  
  months = {
    'JAN' : '01',
    'FEB' : '02',
    'MAR' : '03',
    'APR' : '04',
    'MAY' : '05',
    'JUN' : '06',
    'JUL' : '07',
    'AUG' : '08',
    'SEP' : '09',
    'OCT' : '10',
    'NOV' : '11',
    'DEC' : '12'
  };
  year = new Date().getFullYear();

  if (format == 'google') {

    day = parseInt(date.replace(/\D/g,''));
    if (day < 10) {
      day = '0' + day;
    }

    date = date.toUpperCase();

    Object.keys(months).forEach( function(item,index) {
      if (date.search(item) >= 0) {
        month = months[item];
        return false;
      }
    });

    return '' + year + '' + month + '' + day;

  }
}


export function convertTimeFormat(date) {

  hours = date.split('-');
  if (hours[0].search("am") >= 0) {

    start = hours[0].trim().replace('am','');

    if (start.search(':') >= 0) {

      start.replace(':','');
      if (start.length < 4) {
        start = '0' + start;
      }

      start = '' + start + '00';

    } else {
      
      if (start.length < 2) {
        start = '0' + start;
      }

      start = '' + start + '0000';

    }

  } else {

    start = hours[0].trim().replace('pm','');

    if (start.search(':') >= 0) {

      start.replace(':','');

    }
      
    start = parseInt(start) + 1200;
    start = '' + start + '00';

  }

  if (hours[1].search("am") >= 0) {

    end = hours[1].trim().replace('am','');

    if (end.search(':') >= 0) {

      end.replace(':','');

      if (end.length < 4) {
        end = '0' + end;
      }

    } else {
      if (end.length < 2) {
        end = '0' + end + '00';
      }
	  
       end = '' + end + '0000';  
	  

    }

  } else {

    end = hours[1].trim().replace('pm','');

    if (end.search(':') >= 0) {

      end.replace(':','');

    }
      
    end = (parseInt(end)*100) + 1200;
    end = '' + end + '00';

  }

  return { 0 : start, 1 : end };

}

export function convertTimezone( timezone, startDate ) {

  switch ( timezone ) {
    case "Atlantic":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "ADT";
      } else {
        timeZone = "AST";
      }
    break;
    
    case "Alaska":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "AKDT";
      } else {
        timeZone = "AKST";
      }
    break;
    
    case "Central":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "CDT";
      } else {
        timeZone = "CST";
      }
    break;
    
    case "Eastern":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "EDT";
      } else {
        timeZone = "EST";
      }
    break;
    
    case "Hawaii":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "HADT";
      } else {
        timeZone = "HAST";
      }
    break;
    
    case "Mountain":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "MDT";
      } else {
        timeZone = "MST";
      }
    break;
    
    case "Newfoundland":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "NDT";
      } else {
        timeZone = "NST";
      }
    break;
    
    case "Pacific":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "PDT";
      } else {
        timeZone = "PST";
      }
    break;
    
    case "Pierre & Miquelon":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "PMDT";
      } else {
        timeZone = "PMST";
      }
    break;
    
    case "Western Greenland":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "WGST";
      } else {
        timeZone = "WGT";
      }
    break;
    
    default:
      timeZone = "";

  }

  return timeZone;

}

/*
 * Replace all SVG images with inline SVG
 */
export function embbedSvgImages() {
  var parser = new DOMParser();

  qsa('img.svg').forEach(function(item, index){
    //console.log('item',item);
    var img = item;
    var imgID = img.id;
    var imgClass = img.classList.item(0);
    var imgURL = img.getAttribute('src');

    var httpRequest = new XMLHttpRequest();
    httpRequest.onreadystatechange = function () {
      if(httpRequest.readyState === XMLHttpRequest.DONE && httpRequest.status === 200) {        
        var data = httpRequest.responseText;
        var doc = parser.parseFromString(data, "image/svg+xml");

        var svg = doc.querySelector('svg');

        // Add replaced image's ID to the new SVG
        if(typeof imgID !== 'undefined') {
            svg.setAttribute('id', imgID);
        }
        // Add replaced image's classes to the new SVG
        if(typeof imgClass !== 'undefined') {
            svg.classList.add( imgClass );
            svg.classList.add('replaced-svg');
        }

        svg.removeAttribute('xmlns:a');

        img.parentNode.appendChild(svg);
        img.remove();

      }
      
    }
    httpRequest.open('GET', imgURL);
    httpRequest.send();
  });
}

/*
 * pure JS fade
 */

export function _(el) {
  if (!(this instanceof _)) {
    return new _(el);
  }
  this.el = document.getElementById(el);
}

_.prototype.fade = function fade(type, ms) {
  var isIn = type === 'in',
    opacity = isIn ? 0 : 1,
    interval = 50,
    duration = ms,
    gap = interval / duration,
    self = this;

  if(isIn) {
    self.el.style.display = 'inline';
    self.el.style.opacity = opacity;
  }

  function func() {
    opacity = isIn ? opacity + gap : opacity - gap;
    self.el.style.opacity = opacity;

    if(opacity <= 0) self.el.style.display = 'none'
    if(opacity <= 0 || opacity >= 1) window.clearInterval(fading);
  }

  var fading = window.setInterval(func, interval);
}

/*
 * Pop Up
 */
export function showPopUp( content, footerContent ) {

  if (content !== '') {
    qs('#popup .box-content').innerHTML( content );
  }

  if (footerContent !== '') {
    qs('#popup .box-footer').innerHTML( footerContent );
  } else {
    qs('#popup .box-footer').remove();
  }

  qs('#popup').style.display = '';
  _('#popup').fade('out',0);
  _('#popup').fade('in', 500);

  qs('#popup .close-button').addEventListener('click', function(e){

    e.preventDefault();

    _('#popup').fade('out',0);

  });
}

/**
 * Get the closest matching element up the DOM tree.
 * @private
 * @param  {Element} elem     Starting element
 * @param  {String}  selector Selector to match against
 * @return {Boolean|Element}  Returns null if not match found
 */
export function getClosest ( elem, selector ) {

    // Element.matches() polyfill
    if (!Element.prototype.matches) {
        Element.prototype.matches =
            Element.prototype.matchesSelector ||
            Element.prototype.mozMatchesSelector ||
            Element.prototype.msMatchesSelector ||
            Element.prototype.oMatchesSelector ||
            Element.prototype.webkitMatchesSelector ||
            function(s) {
                var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                    i = matches.length;
                while (--i >= 0 && matches.item(i) !== this) {}
                return i > -1;
            };
    }

    // Get closest match
    for ( ; elem && elem !== document; elem = elem.parentNode ) {
        if ( elem.matches( selector ) ) return elem;
    }

    return null;

}



// WEBPACK FOOTER //
// ./src/assets/js/functions-vanilla.js